export const PayrollOverviewsListingGetters = {
  PayrollOverviewsGenerationLoading: 'PayrollOverviewsGenerationLoading',
  PayrollOverviews: 'PayrollOverviewsListingGetters.PayrollOverviews',
  PayrollOverviewsSortOrder: 'PayrollOverviewsListingGetters.PayrollOverviewsSortOrder',
  PayrollOverviewsSortBy: 'PayrollOverviewsListingGetters.PayrollOverviewsSortBy',
  PayrollOverviewsSortDirection: 'PayrollOverviewsListingGetters.PayrollOverviewsSortDirection',
  PayrollOverviewsCount: 'PayrollOverviewsListingGetters.PayrollOverviewsCount',
  PayrollOverviewsPerPage: 'PayrollOverviewsListingGetters.PayrollOverviewsPerPage',
  PayrollOverviewsListingOffset: 'PayrollOverviewsListingGetters.PayrollOverviewsListingOffset',
  PayrollOverviewsIsLoading: 'PayrollOverviewsListingGetters.PayrollOverviewsIsLoading',
  PayrollOverviewsPaginationParams:
    'PayrollOverviewsListingGetters.PayrollOverviewsPaginationParams',
  ProcessedTimeSheetCount: 'PayrollOverviewListingGetters.ProcessedTimeSheetCount'
};

export const PayrollOverviewsListingActions = {
  RetrievePayrollOverviews: 'PayrollOverviewsListingActions.RetrievePayrollOverviews',
  RetrievePayrollOverviewsFilteredRecordCount:
    'PayrollOverviewsListingActions.RetrievePayrollOverviewsFilteredRecordCount',
  SetPayrollOverviewsSortOrder: 'PayrollOverviewsListingActions.SetPayrollOverviewsSortOrder',
  SetPayrollOverviewsFilters: 'PayrollOverviewsListingActions.SetPayrollOverviewsFilters',
  SetPayrollOverviewsPaginationParameters:
    'PayrollOverviewsListingActions.SetPayrollOverviewsPaginationParameters',
  FilterListBySearchKey: 'PayrollOverviewsListingActions.FilterListBySearchKey',
  ExportList: 'PayrollOverviewsListingActions.ExportList',
  GeneratePayrollOverview: 'PayrollOverviewsListingActions.GeneratePayrollOverview',
  UpdateProcessedTimeSheetCount: 'PayrollOverviewsListingActions.UpdateProcessedTimeSheetCount'
};

export const PayrollOverviewsListingMutations = {
  SetPayrollOverviewsGenerationLoading: 'SetPayrollOverviewsGenerationLoading',
  SetPayrollOverviewsList: 'PayrollOverviewsListingMutations.SetPayrollOverviewsList',
  SetPayrollOverviewsFilteredRecordCount:
    'PayrollOverviewsListingMutations.SetPayrollOverviewsFilteredRecordCount',
  SetPayrollOverviewsSortOrder: 'PayrollOverviewsListingMutations.SetPayrollOverviewsSortOrder',
  SetPayrollOverviewsFilters: 'PayrollOverviewsListingMutations.SetPayrollOverviewsFilters',
  ResetPayrollOverviewsPaginationOffset:
    'PayrollOverviewsListingMutations.ResetPayrollOverviewsPaginationOffset',
  SetPayrollOverviewsPaginationParameters:
    'PayrollOverviewsListingMutations.SetPayrollOverviewsPaginationParameters',
  SetPayrollOverviewsLoading: 'PayrollOverviewsListingMutations.SetPayrollOverviewsLoading',
  SetSearchParam: 'PayrollOverviewsListingMutations.SetSearchParam',
  SetProcessedTimeSheetCount: 'PayrollOverviewsListingMutations.SetProcessedTimeSheetCount'
};
